module.exports = __webpack_public_path__ + "img/internalFooter.e6d738cd.png";